import { useEffect, useState } from 'react';

// 「网站管理」直达中转页：新标签打开本路由后立即完成交接并跳转 CMS。
// 流程：读取当前控制台会话 → 同域 CMS /api/handoff 换取单次兑换码（30 秒）
// → location.replace(CMS#h=code) → CMS 兑换出自己的会话并进入已登录状态。
// 不使用 window.open（不存在弹窗拦截问题）；失败时在本页显示原因。
export function OpenWebsiteCmsPage() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const session = localStorage.getItem('integral_token')
          || localStorage.getItem('integral_identity_session')
          || '';
        if (!session) {
          setError('尚未登录 Integral，请先登录控制台');
          return;
        }
        const cmsBase = window.location.origin + '/website-cms/';
        const res = await fetch(cmsBase + 'api/handoff', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session }),
        });
        const d = await res.json().catch(() => ({}));
        if (!res.ok || !d.code) {
          setError(d.error || `后台返回 ${res.status}`);
          return;
        }
        if (!cancelled) window.location.replace(cmsBase + '#h=' + d.code);
      } catch {
        if (!cancelled) setError('无法连接官网后台（服务可能未启动），请稍后重试');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div style={{ maxWidth: 640, margin: '80px auto', padding: '0 20px', textAlign: 'center', lineHeight: 1.8 }}>
      {error ? (
        <>
          <h1 style={{ fontSize: 20, marginBottom: 10 }}>无法打开网站管理</h1>
          <p style={{ color: '#b91c1c', marginBottom: 16 }}>{error}</p>
          <p style={{ color: '#64748b', fontSize: 13.5 }}>
            也可从 <a href="/website-admin" style={{ color: '#2563eb' }}>入口页</a> 手动建立会话，
            或返回{' '}
            <a href="/" style={{ color: '#2563eb' }}>控制台首页</a>。
          </p>
        </>
      ) : (
        <p style={{ color: '#64748b' }}>正在打开网站管理后台…</p>
      )}
    </div>
  );
}
